import * as Sentry from '@sentry/react'
import { deveGravarReplay, ehPaginaDoEnvio, nomeDaPaginaEnvio } from './sentry-envio'

const AMOSTRA_PADRAO = import.meta.env.PROD ? 0.2 : 1.0

/**
 * Prefixo da API das functions (outro domínio): sem ele na lista o navegador não manda o trace e a API
 * abre outro. O prefixo completo (não só a origem) deixa de fora o supabase-js (auth/rest/storage).
 */
const API: string | null = import.meta.env.VITE_API_URL || null

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({
      // Envio do funcionário: uma transação de carregamento por rota, não por empresa (slug no caminho).
      beforeStartSpan: (opcoes) => {
        const nome = nomeDaPaginaEnvio(window.location)
        return nome ? { ...opcoes, name: nome } : opcoes
      },
    }),
    // Masking ligado: a tela do avaliador exibe CID, CPF e nome de funcionario.
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
      beforeErrorSampling: deveGravarReplay,
    }),
  ],
  // Envio do funcionário: volume baixo (um acesso por atestado) e é a porta de entrada dos documentos —
  // mede tudo. O resto do app segue em 20% em produção. A API herda a decisão pelo trace.
  tracesSampler: ({ inheritOrSampleWith }) =>
    inheritOrSampleWith(ehPaginaDoEnvio(window.location) ? 1.0 : AMOSTRA_PADRAO),
  tracePropagationTargets: API ? ['localhost', /^\//, API] : ['localhost', /^\//],
  // Só grava sessões que terminam em erro — evita volume de replay de navegação normal.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
})
